<div
  class="vdd-row flex gt-sm:flex-row lt-md:flex-col gt-sm:justify-start gt-sm:items-center lt-md:justify-center lt-md:items-center"
>
  <div class="word-break">
    <div class="vdd-name-container flex flex-col justify-center items-start">
      <div class="vdd-name">{{ 'TI_' + vddName | translate }}</div>
      <small data-at-vdd-name>{{ vddName }}</small>
      <small>{{ logicalLink }}</small>
    </div>
  </div>
  <div
    *ngIf="isVddLoading; else vddLoaded"
    class="flex flex-row justify-center items-center flex-[100%] max-w-[50%]"
  >
    <mat-spinner></mat-spinner>
  </div>
  <ng-template #vddLoaded>
    <ng-container *ngIf="matchedValues?.length; else readError">
      <app-diagnostics-default-template
        [vddName]="vddName"
        [logicalLink]="logicalLink"
        [saveValue]="saveValueSubject"
        [diagnosticsFormGroupService]="diagnosticsFormGroupService"
      ></app-diagnostics-default-template>
    </ng-container>
    <ng-template #readError>
      <vi-alert>
        <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
      </vi-alert>
    </ng-template>
  </ng-template>
</div>
